import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

export default function ProgressBar({ contentRef }) {
  const progressBarRef = useRef(undefined);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      function scrolling() {
        const winScroll =
          document.body.scrollTop || document.documentElement.scrollTop;
        const height = contentRef.current
          ? contentRef.current.scrollHeight -
            document.documentElement.clientHeight +
            80
          : document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;
        if (progressBarRef.current)
          return (progressBarRef.current.style.width = scrolled + '%');
      }
      window.addEventListener('scroll', scrolling);
      return () => {
        window.removeEventListener('scroll', scrolling);
      };
    }
  });

  return (
    <Container>
      <Bar ref={progressBarRef} />
    </Container>
  );
}

export const Container = styled.div`
  width: 100%;
  height: 4px;
  position: fixed;
  z-index: ${(props) => props.theme.zIndex.appBar - 1};
`;

export const Bar = styled.div`
  height: 4px;
  background: ${(props) => props.theme.palette.primary.main};
  width: 0%;
`;
